import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 1.2em;
  font-weight: bold;
  text-align: center;
  margin: 1em;
  color: #fff;
  overflow-wrap: break-word;
       @media (min-width: 768px) {
          font-size: 2em;
    }
`;